module.exports = __webpack_public_path__ + "static/media/logo_lazada.778eae35.svg";